import * as z from "zod";

export const ToteNamingConfigSchema = z.object({
  prefix: z.string(),
  separator: z.enum(["-", "_"]),
  minDigits: z.number().int().min(1).max(6),
});

export type ToteNamingConfig = z.infer<typeof ToteNamingConfigSchema>;

export const DEFAULT_TOTE_NAMING_CONFIG: ToteNamingConfig = {
  prefix: "",
  separator: "-",
  minDigits: 3,
};

export function buildToteName(
  config: ToteNamingConfig,
  groupName: string,
  index: number,
): string {
  const prefix = config.prefix.trim() || groupName;
  const seq = String(index).padStart(config.minDigits, "0");
  return `${prefix}${config.separator}ST${config.separator}${seq}`;
}

export function buildToteNamePattern(
  config: ToteNamingConfig,
  groupName: string,
): string {
  const prefix = config.prefix.trim() || groupName;
  const placeholder = "x".repeat(config.minDigits);
  return `${prefix}${config.separator}ST${config.separator}${placeholder}`;
}
